/*
 * ===========================================================================
 * SEPET SORU FORMU - mantik katmani
 * Dosya yolu: assets/custom-sample-gate.js
 * ---------------------------------------------------------------------------
 * IKI SORU GRUBU:
 *   "sample" -> varyant secenek degeri "Free Sample" olan satir varsa acilir
 *   "tile"   -> Product type'i "Tile" olan urun varsa acilir
 *   Iki kontrol bagimsiz; ikisi birden varsa iki grup da acilir.
 *
 * - Cevaplari /cart/update.js ile cart attribute olarak kaydeder
 * - Aktif gruptaki alanlar eksikken checkout'u engeller
 *   (fail-open: JS patlarsa sepet normal calisir)
 * - Form eksikken hizli odeme butonlarini (Shop Pay / PayPal) gizler
 * - Sepet cekmecesinden checkout'a basilirsa sepet sayfasina yonlendirir
 * - Numune adedi sinirini asarsa checkout'u engeller (snippet'te max_samples
 *   0 ise sinir yoktur, bu kontrol hic calismaz)
 * - Gizli gruptaki alanlar dogrulanmaz, kaydedilmez, sepetten silinir
 * ===========================================================================
 */
(function () {
  if (window.__sampleGateInit) return;
  window.__sampleGateInit = true;

  // Bu on eklerle baslayan cart attribute'lar bize aittir. Formdan cikardigimiz
  // ya da o an gecerli olmayan bir alan varsa musterinin sepetinde asili
  // kalmasin diye otomatik temizleniyor - bkz. purgeStaleAttributes().
  var ATTR_PREFIXES = ['Sample - ', 'Delivery - '];
  var CHECKOUT_SELECTOR = '#checkout, #CartDrawer-Checkout, button[name="checkout"], input[name="checkout"]';
  var DYNAMIC_SELECTOR =
    '.cart__dynamic-checkout-buttons, .additional-checkout-buttons, [data-shopify="dynamic-checkout-cart"]';

  var state = {
    sampleQty: 0,
    tileQty: 0,
    max: Infinity, // snippet'teki max_samples; 0/bos = sinirsiz
    values: [], // numune sayilan varyant secenek degerleri
    tileTypes: [], // teslimat sorusu tetikleyen Product type degerleri (kucuk harf)
    required: [],
    attributes: null, // /cart.js'ten gelen guncel attribute'lar
    saving: false,
  };

  /* ---------------------------------------------------------------- utils */

  function routeRoot() {
    return (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  }

  function roots() {
    return Array.prototype.slice.call(document.querySelectorAll('[data-sample-gate]'));
  }

  // Yalnizca ACIK gruplardaki alanlar: gizli grubun sorulari ne dogrulanir
  // ne de sepete yazilir.
  function fieldsOf(root) {
    return Array.prototype.slice.call(root.querySelectorAll('[data-sample-field]')).filter(function (el) {
      var group = el.closest('[data-sample-group]');
      return !group || !group.hidden;
    });
  }

  function activeGroups() {
    return { sample: state.sampleQty > 0, tile: state.tileQty > 0 };
  }

  function anyActive() {
    return state.sampleQty > 0 || state.tileQty > 0;
  }

  function activeRoots() {
    return roots().filter(function (r) {
      return !r.hidden;
    });
  }

  function fullRoots() {
    return activeRoots().filter(function (r) {
      return fieldsOf(r).length > 0;
    });
  }

  function isOurs(key) {
    return ATTR_PREFIXES.some(function (prefix) {
      return key.indexOf(prefix) === 0;
    });
  }

  function debounce(fn, wait) {
    var t;
    return function () {
      clearTimeout(t);
      t = setTimeout(fn, wait);
    };
  }

  function splitList(value) {
    return (value || '')
      .split(',')
      .map(function (s) {
        return s.trim();
      })
      .filter(Boolean);
  }

  /* --------------------------------------------------------------- config */

  // DIKKAT: adetler yalnizca acilista DOM'dan okunur. Sepet sayfasindaki blok
  // Dawn tarafindan yeniden render EDILMEDIGI icin data-*-qty bayatliyor;
  // ilk yuklemeden sonra adetler her zaman /cart.js'ten alinir.
  function readConfig(includeQty) {
    var root = roots()[0];
    if (!root) return false;
    // 0, bos veya gecersiz deger -> sinir yok
    var max = parseInt(root.dataset.maxSamples || '0', 10);
    state.max = max > 0 ? max : Infinity;
    if (includeQty) {
      state.sampleQty = parseInt(root.dataset.sampleQty || '0', 10);
      state.tileQty = parseInt(root.dataset.tileQty || '0', 10);
    }
    state.values = splitList(root.dataset.sampleValues);
    state.tileTypes = splitList(root.dataset.tileTypes).map(function (s) {
      return s.toLowerCase();
    });
    try {
      state.required = JSON.parse(root.dataset.sampleRequired || '[]');
    } catch (e) {
      state.required = [];
    }
    return true;
  }

  /* ----------------------------------------------------------- validation */

  function valueValid(value, rule, optional) {
    var v = (value || '').trim();
    if (!v) return !!optional;
    switch (rule) {
      case 'tel':
        return (v.match(/\d/g) || []).length >= 10;
      case 'number':
        return parseFloat(v) >= 1;
      case 'decimal': {
        // "45,5" ve "45.5" ikisi de gecerli
        if (!/^\d{1,7}([.,]\d{1,3})?$/.test(v)) return false;
        return parseFloat(v.replace(',', '.')) > 0;
      }
      case 'text':
        return v.length >= 2;
      case 'longtext':
        return v.length >= 10;
      default:
        // 'select' ve 'any': dolu olmasi yeterli
        return true;
    }
  }

  function isValid(el) {
    return valueValid(el.value, el.dataset.validate, el.hasAttribute('data-optional'));
  }

  function mark(el, ok) {
    var wrap = el.closest('.sample-gate__field');
    if (wrap) wrap.classList.toggle('sample-gate__field--error', !ok);
  }

  // Formun bulunmadigi sayfalarda (cekmece) kayitli attribute'lara bakilir
  function attributesComplete() {
    if (!state.attributes) return false;
    if (!state.required.length) return true;
    var attrs = state.attributes;
    var active = activeGroups();
    return state.required.every(function (spec) {
      if (spec.group && !active[spec.group]) return true; // grup kapali, sorma
      return valueValid(attrs[spec.key], spec.validate, spec.optional);
    });
  }

  function isComplete() {
    if (!anyActive()) return true;
    var full = fullRoots();
    if (full.length) {
      return full.every(function (r) {
        return fieldsOf(r).every(isValid);
      });
    }
    return attributesComplete();
  }

  // Gorunen zorunlu alanlarin kaci dolu? Opsiyoneller sayilmaz.
  function progress() {
    var total = 0;
    var done = 0;
    fullRoots().forEach(function (root) {
      fieldsOf(root).forEach(function (el) {
        if (el.hasAttribute('data-optional')) return;
        total++;
        if (isValid(el)) done++;
      });
    });
    return { total: total, done: done, left: total - done };
  }

  // Bos zorunlu alanlari isaretle. Hata degil - "sirada bu" anlaminda,
  // musteri henuz hicbir seye dokunmadan da hangilerinin kaldigini gorur.
  function markTodo() {
    fullRoots().forEach(function (root) {
      fieldsOf(root).forEach(function (el) {
        var wrap = el.closest('.sample-gate__field');
        if (!wrap) return;
        var todo = !el.hasAttribute('data-optional') && !isValid(el);
        wrap.classList.toggle('sample-gate__field--todo', todo);
      });
    });
  }

  function validateAll(showErrors) {
    var full = fullRoots();
    if (!full.length) return isComplete();

    var ok = true;
    var firstBad = null;
    full.forEach(function (root) {
      fieldsOf(root).forEach(function (el) {
        var valid = isValid(el);
        if (showErrors) mark(el, valid);
        if (!valid) {
          ok = false;
          if (!firstBad && el.offsetParent !== null) firstBad = el;
        }
      });
    });
    if (showErrors && firstBad) {
      firstBad.scrollIntoView({ behavior: 'smooth', block: 'center' });
      setTimeout(function () {
        firstBad.focus({ preventScroll: true });
      }, 300);
    }
    return ok;
  }

  /* ----------------------------------------------------------------- sync */

  function collect(root) {
    var out = {};
    fieldsOf(root).forEach(function (el) {
      var v = (el.value || '').trim();
      if (el.dataset.validate === 'decimal') v = v.replace(',', '.');
      out[el.dataset.sampleField] = v;
    });
    return out;
  }

  function fill(values) {
    roots().forEach(function (root) {
      fieldsOf(root).forEach(function (el) {
        var key = el.dataset.sampleField;
        if (!(key in values)) return;
        if (el === document.activeElement) return; // yazmakta olani ezme
        if (el.value === values[key]) return;
        el.value = values[key];
      });
    });
  }

  function save(root) {
    var attrs = collect(root);
    fill(attrs);
    state.attributes = Object.assign({}, state.attributes || {}, attrs);
    state.saving = true;
    return fetch(routeRoot() + 'cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ attributes: attrs }),
    })
      .catch(function () {
        /* sessizce gec - form post'u zaten yedek */
      })
      .then(function () {
        state.saving = false;
      });
  }

  /* ------------------------------------------------------------ cart read */

  // Shopify cart attribute'lari BIRLESTIRIR, degistirmez: /cart/update.js'e
  // gonderdigin alanlar yazilir ama gondermediklerin sepette asili kalir.
  // Burada bize ait olup o an gecerli OLMAYAN her alan bos degere cekilerek
  // siliniyor. Gecersiz olmasinin iki sebebi olabilir:
  //   1) alan formdan tamamen kaldirilmis (orn. eski "Sample - Phone")
  //   2) alanin grubu kapali (numune cikarilmis ama cevaplari sepette kalmis)
  function purgeStaleAttributes() {
    if (!state.attributes || !state.required.length) return;

    var active = activeGroups();
    var valid = state.required
      .filter(function (spec) {
        return !spec.group || active[spec.group];
      })
      .map(function (spec) {
        return spec.key;
      });

    var stale = {};
    var found = false;

    Object.keys(state.attributes).forEach(function (key) {
      if (!isOurs(key)) return; // baskasinin alani, dokunma
      if (valid.indexOf(key) !== -1) return; // hala kullaniliyor
      if (!state.attributes[key]) return; // zaten bos
      stale[key] = '';
      found = true;
    });

    if (!found) return;

    Object.keys(stale).forEach(function (key) {
      delete state.attributes[key];
    });

    fetch(routeRoot() + 'cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ attributes: stale }),
    }).catch(function () {});
  }

  function fetchCart() {
    return fetch(routeRoot() + 'cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) {
        return r.json();
      })
      .then(function (cart) {
        var sample = 0;
        var tile = 0;

        // Her satir TEK bir gruba girer:
        //   varyant secenek degeri "Free Sample" -> numune sorulari
        //   degilse Product type   "Tile"        -> teslimat sorulari
        // Numune satiri tile sayilmaz: numune kucuk paketle gidiyor.
        (cart.items || []).forEach(function (item) {
          var values = (item.options_with_values || []).map(function (o) {
            return String(o.value).trim();
          });
          var isSample = values.some(function (v) {
            return state.values.indexOf(v) !== -1;
          });
          if (isSample) {
            sample += item.quantity;
            return;
          }

          var type = String(item.product_type || '')
            .trim()
            .toLowerCase();
          if (type && state.tileTypes.indexOf(type) !== -1) tile += item.quantity;
        });

        state.sampleQty = sample;
        state.tileQty = tile;
        state.attributes = cart.attributes || {};
        // Once gruplari dogru ac/kapa: fill() ve purge() gizli gruplari atlar
        applyGroups();
        fill(state.attributes);
        purgeStaleAttributes();
        return cart;
      })
      .catch(function () {
        return null;
      });
  }

  /* ------------------------------------------------------------ ui update */

  function setNotice(text) {
    roots().forEach(function (root) {
      var el = root.querySelector('[data-sample-notice]');
      if (!el) return;
      if (text) {
        el.textContent = text;
        el.setAttribute('data-open', '');
      } else {
        el.textContent = '';
        el.removeAttribute('data-open');
      }
    });
  }

  // Blok ve grup gorunurlugu. Sadece degistiyse yaziyoruz: aksi halde
  // MutationObserver tetiklenip sonsuz refresh dongusu olusuyor.
  function applyGroups() {
    var active = activeGroups();
    var any = anyActive();

    roots().forEach(function (root) {
      if (root.hidden !== !any) root.hidden = !any;

      root.querySelectorAll('[data-sample-group]').forEach(function (group) {
        var on = active[group.dataset.sampleGroup] === true;
        if (group.hidden !== !on) group.hidden = !on;
      });

      var counter = root.querySelector('[data-sample-count]');
      if (counter && counter.textContent !== String(state.sampleQty)) {
        counter.textContent = state.sampleQty;
      }

      // "1 free sample" / "2 free samples"
      var plural = state.sampleQty === 1 ? '' : 's';
      root.querySelectorAll('[data-sample-plural]').forEach(function (el) {
        if (el.textContent !== plural) el.textContent = plural;
      });
    });
  }

  // Ilerleme seridi: "3 of 5 answered"
  function setStatus(p) {
    roots().forEach(function (root) {
      var box = root.querySelector('[data-sample-status]');
      if (!box) return;

      var show = p.total > 0;
      if (box.hidden !== !show) box.hidden = !show;
      if (!show) return;

      var text = p.left === 0 ? 'All questions answered' : p.done + ' of ' + p.total + ' answered';
      var label = box.querySelector('[data-sample-status-text]');
      if (label && label.textContent !== text) label.textContent = text;

      var bar = box.querySelector('[data-sample-bar]');
      var width = Math.round((p.done / p.total) * 100) + '%';
      if (bar && bar.style.width !== width) bar.style.width = width;

      box.classList.toggle('sample-gate__status--done', p.left === 0);
    });
  }

  // Checkout butonunun altina "neden basilmiyor" aciklamasi. Tiklaninca
  // ilk eksik alana goturur; cekmecede sepet sayfasina yonlendirir.
  function setHints(blocked, p) {
    document.querySelectorAll(CHECKOUT_SELECTOR).forEach(function (btn) {
      if (btn.closest('[data-sample-gate]')) return;
      var host = btn.closest('.cart__ctas') || btn.parentElement;
      if (!host) return;

      var el = host.querySelector('[data-sample-hint]');
      if (!blocked) {
        if (el) el.remove();
        return;
      }
      if (!el) {
        el = document.createElement('button');
        el.type = 'button';
        el.className = 'sample-gate__hint';
        el.setAttribute('data-sample-hint', '');
        host.appendChild(el);
      }

      var text;
      if (state.sampleQty > state.max) {
        text = 'Too many free samples in your cart';
      } else if (!fullRoots().length) {
        text = 'Answer a few quick questions on the cart page to continue';
      } else if (p.left === 1) {
        text = '1 question left before you can check out';
      } else {
        text = p.left + ' questions left before you can check out';
      }
      if (el.textContent !== text) el.textContent = text;
    });
  }

  function applyState() {
    applyGroups();
    markTodo();

    var p = progress();
    var over = state.sampleQty > state.max;

    // Sepet sayfasindayiz ama form yok -> snippet render edilmemis.
    // Kilitlemek musteriyi cikissiz birakir; sessizce devre disi kal.
    var formMissing = onCartPage() && !fullRoots().length;
    var blocked = anyActive() && !formMissing && (over || !isComplete());

    setStatus(p);
    setHints(blocked, p);

    document.querySelectorAll(CHECKOUT_SELECTOR).forEach(function (btn) {
      if (btn.closest('[data-sample-gate]')) return;
      if (blocked) {
        btn.setAttribute('aria-disabled', 'true');
        btn.dataset.sampleLocked = '1';
      } else if (btn.dataset.sampleLocked === '1') {
        btn.removeAttribute('aria-disabled');
        delete btn.dataset.sampleLocked;
      }
    });

    // Hizli odeme butonlari (Shop Pay / Google Pay / PayPal) sepet formunu
    // atlatabiliyor. Bu yuzden SADECE form eksikken gizleniyorlar; form
    // tamamlaninca geri geliyorlar - cevaplar zaten sepete kaydedildigi icin
    // hizli odemeyle giden siparise de tasiniyor.
    document.querySelectorAll(DYNAMIC_SELECTOR).forEach(function (el) {
      if (blocked) {
        el.style.display = 'none';
        el.dataset.sampleHidden = '1';
      } else if (el.dataset.sampleHidden === '1') {
        el.style.display = '';
        delete el.dataset.sampleHidden;
      }
    });

    setNotice(
      over
        ? 'We can send a maximum of ' +
            state.max +
            ' free samples per order. Your cart currently has ' +
            state.sampleQty +
            '. Please reduce the quantity to continue.'
        : ''
    );
  }

  function refresh() {
    readConfig(false);
    return fetchCart().then(applyState);
  }

  /* --------------------------------------------------------------- events */

  // NOT: capture asamasinda dinliyoruz ve olayi durduruyoruz. Dawn'in
  // <cart-items> / <cart-drawer-items> elementleri kendi icindeki her change
  // olayini miktar degisikligi sanip validateQuantity() calistiriyor; bu da
  // "You can only add this item in increments of ..." uyarisi uretiyor.
  document.addEventListener(
    'change',
    function (e) {
      var el = e.target.closest && e.target.closest('[data-sample-field]');
      if (!el) return;
      e.stopPropagation();
      mark(el, isValid(el));
      var root = el.closest('[data-sample-gate]');
      if (root) save(root);
      applyState();
    },
    true
  );

  document.addEventListener(
    'input',
    function (e) {
      var el = e.target.closest && e.target.closest('[data-sample-field]');
      if (!el) return;
      e.stopPropagation();
      if (isValid(el)) mark(el, true);
      applyState();
    },
    true
  );

  function goToCart() {
    window.location.href = routeRoot() + 'cart';
  }

  // Zaten sepet sayfasinda miyiz? (dil onekli /en-gb/cart de eslesir)
  function onCartPage() {
    return /(^|\/)cart\/?$/.test(window.location.pathname);
  }

  // Butonun altindaki aciklamaya tiklama: eksik alana goturur
  document.addEventListener('click', function (e) {
    var hint = e.target.closest && e.target.closest('[data-sample-hint]');
    if (!hint) return;
    e.preventDefault();
    if (!fullRoots().length) {
      if (!onCartPage()) goToCart();
      return;
    }
    validateAll(true);
  });

  // Checkout butonuna tiklama - eksikse durdur
  document.addEventListener(
    'click',
    function (e) {
      var btn = e.target.closest && e.target.closest(CHECKOUT_SELECTOR);
      if (!btn || btn.closest('[data-sample-gate]')) return;
      if (!anyActive()) return;

      if (state.sampleQty > state.max) {
        e.preventDefault();
        e.stopPropagation();
        var first = activeRoots()[0];
        if (first) first.scrollIntoView({ behavior: 'smooth', block: 'center' });
        return;
      }

      // Tam form bu sayfada yoksa (cekmece) musteriyi sepet sayfasina gonder.
      // GUVENLIK: zaten sepet sayfasindaysak form hic render edilmemis
      // demektir (orn. main-cart-items.liquid'e eklenmemis ya da tema
      // guncellemesiyle silinmis). Yonlendirirsek musteri sonsuz donguye
      // girip hicbir zaman odeme yapamaz - bu yuzden checkout'a izin ver.
      if (!fullRoots().length) {
        if (onCartPage()) return;
        if (!isComplete()) {
          e.preventDefault();
          e.stopPropagation();
          goToCart();
        }
        return;
      }

      if (!validateAll(true)) {
        e.preventDefault();
        e.stopPropagation();
      }
    },
    true
  );

  // Form gonderimi - yedek kilit (klavyeden enter vb.)
  document.addEventListener(
    'submit',
    function (e) {
      var form = e.target;
      if (!form || (form.id !== 'cart' && form.id !== 'CartDrawer-Form')) return;
      if (!anyActive()) return;
      // Form render edilmemisse engelleme - bkz. click handler'daki aciklama
      if (onCartPage() && !fullRoots().length) return;
      if (state.sampleQty > state.max || !validateAll(true)) {
        e.preventDefault();
        e.stopPropagation();
      }
    },
    true
  );

  /* ------------------------------------------------------- cart lifecycle */

  function boot() {
    if (!readConfig(true)) return;
    applyState();

    // Sepette bir sey varsa bir kez sepeti oku: hem cekmecedeki kilit karari
    // kayitli attribute'lara bagli, hem de eski alanlarin temizligi burada olur.
    if (anyActive()) refresh();

    // Dawn'in pubsub'i: sepete ekleme / adet degisimi / satir silme
    if (typeof window.subscribe === 'function') {
      window.subscribe('cart-update', function () {
        if (!state.saving) refresh();
      });
    }

    // Cekmece tamamen yeniden render ediliyor -> DOM degisimini de izle
    var observed = document.querySelectorAll('cart-drawer, cart-items, #main-cart-footer');
    if (observed.length) {
      var onMutate = debounce(function () {
        if (state.saving) return;
        refresh();
      }, 250);
      var obs = new MutationObserver(onMutate);
      observed.forEach(function (node) {
        obs.observe(node, { childList: true, subtree: true });
      });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
